module.exports = __webpack_public_path__ + "static/media/magento2.d4c8713b.PNG";